/* 夏侯淵傳・第 4 章：長離・興國（214 年）
 * 東南是略陽城外的夏侯淵營（輜重留在這裡），東北是韓遂大營，北邊是氐人的興國城；西邊是長離諸羌的四座屯。 */
export const CAMP = [7000, 3900], HAN = [8000, 1400], XINGGUO = { x: 4600, y: 1100, hw: 520, hh: 340 }, QIANG = [[1300, 1500], [900, 3100], [2300, 4100], [2600, 2300]];
export const FIELD = [4300, 3000], DITCH = [4800, 3600]; // 對陣的地方、諸將想結營作塹的地方
const T = 34, G = 120, X = XINGGUO, N = X.y - X.hh, S = X.y + X.hh, Wx = X.x - X.hw, E = X.x + X.hw;
export const XG_GATE = [X.x, S];
export default {
  id: 'xiahouyuan_changli', name: '略陽・長離', W: 9000, H: 5200, seed: 2141,
  bases: [CAMP, HAN],
  walls: [[X.x, N, X.hw + T, T], [Wx, X.y, T, X.hh], [E, X.y, T, X.hh], [(Wx + X.x - G) / 2, S, (X.x - G - Wx) / 2 + T, T], [(X.x + G + E) / 2, S, (E - X.x - G) / 2 + T, T]],
  roads: [
    { pts: [CAMP, [5600, 3300], FIELD, [3300, 2700], [2600, 2300], QIANG[0]], w: 130 },
    { pts: [CAMP, [7600, 2600], HAN], w: 110 },
    { pts: [[5600, 3300], [4800, 2200], XG_GATE, [X.x, X.y]], w: 110 },
    { pts: [QIANG[0], QIANG[1], QIANG[2], [3200, 3700], FIELD], w: 100 },
  ],
  rocks: [[6000, 800, 420, 200], [2200, 700, 420, 200], [5200, 4500, 420, 180], [8200, 4400, 380, 170], [1600, 2400, 260, 140]],
  woods: 0.4,
  sight: 0.85,
  clearings: [[CAMP[0], CAMP[1], 500], [HAN[0], HAN[1], 600], [X.x, X.y + X.hh + 200, 300], ...QIANG.map(([x, y]) => [x, y, 360]), [FIELD[0], FIELD[1], 700], [DITCH[0], DITCH[1], 300]],
  villages: [{ x: X.x, y: X.y, n: 6, r: 300 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 5, r: 340, chief: true, col: '#3b5a99', flag: '夏' }, { x: HAN[0], y: HAN[1], n: 7, r: 440, chief: true, col: '#6a3a2a', flag: '韓' }, ...QIANG.map(([x, y]) => ({ x, y, n: 3, r: 240, col: '#8a6a4a', flag: '羌' }))],
  grass: [[3000, 1500, 220, 100], [1700, 3700, 220, 100]],
};
